import {FC} from 'react';
import {Outlet} from 'react-router-dom';
//mui
import {Box} from '@mui/material';
//components
import ProfileHeader from './ProfileHeader';
//styles
import {profileTemplateStyle} from './ProfileTemplate.styles';

const ProfileTemplate: FC = () => (
	<Box sx={profileTemplateStyle.wrapper}>
		<ProfileHeader />
		<Outlet />
	</Box>
);

export default ProfileTemplate;
